<template>
  <div>
    <!-- <el-popover placement="bottom" ref="poptipModal" trigger="click"> -->
    <Poptip placement="bottom" ref="poptipModal">
      <template #content>
        <div
          style="
            display: flex;
            flex-direction: column;
            align-items: center;
            padding: 20px;
          "
        >
          <div style="margin-bottom: 20px">
            请选择科室：
            <el-cascader
              filterable
              v-model="deskId"
              :options="branchList"
              :props="cascaderKey"
              clearable
            ></el-cascader>
          </div>
          <div>
            <Button
              type="primary"
              class="modal_content_btn_ok"
              @click="onModalSubmit"
              >确定</Button
            >
          </div>
        </div>
      </template>
      <div
        style="
          display: block;
          min-width: 100px;
          height: 30px;
          line-height: 30px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        "
      >
        <span style="color: red">{{ isImportant == 1 ? "☆" : "" }}</span>
        <span v-show="row.department">
          {{ row.department }}
        </span>
        <span v-show="!row.department" style="color: red"
          >选择来电科室</span
        >
      </div>
    </Poptip>
    <!-- </el-popover> -->
  </div>
</template>

<script>
export default {
  props: ["isImportant", "row", "branchList", "resetList"],
  data() {
    return {
      deskId: "",
      cascaderKey: {
        value: "id",
        label: "deskName",
        checkStrictly: true,
        emitPath: false,
      },
    };
  },
  created() {},
  methods: {
    async onModalSubmit() {
      let d = {
        callno: this.row.callno,
        deskId: this.deskId,
      };
      if (!this.deskId) {
        $utils.toast.error("请选择科室！");
        return;
      }
      let res = await $utils.api.load(
        "/admin/system/record/updateFrame",
        d,
        "PUT"
      );
      if (res.code == 200) {
        this.deskId = "";
        $utils.toast.success("修改成功！");
        this.$refs.poptipModal.handleClose();
        this.$emit("resetList");
      }
    },
  },
};
</script>

<style></style>